<template>
  <div class="pb-5 my-team-parent">
    <div class="card-filter-section mb-50 mt-0 d-flex align-items-center justify-content-between">
      <p class="task-timesheet m-0">
        Resumes
      </p>
      <Help
        v-show="$store.state.app.userManualList"
        code="ResumeList"
      />
    </div>
    <!-- Filter start -->
    <div class="card-filter-section">
      <div class="d-flex align-items-center flex-wrap justify-content-between">
        <div style="width : 100%">
          <div class="d-flex align-items-center justify-content-start w-100">
            <p class="filter-title">
              Filters:
            </p>
            <div class="mr-75 ml-1">
              <custom-dropdown
                v-model="is_active"
                :options="isActiveList"
                :search-box="false"
                :hide-close="true"
                label="Active"
              />
            </div>
            <div>
              <custom-dropdown
                v-model="manage_by"
                :options="manage_by_users"
                label="Managed by"
              />
            </div>
            <div>
              <custom-dropdown
                v-model="reporting_to"
                :options="reporting_to_users"
                label="Reporting to"
              />
            </div>
            <div
              v-show="primarySkills.length && secondarySkills.length"
              class="ml-50 my-team-skill-button"
            >
              [
            </div>

            <div>
              <custom-dropdown
                v-model="primarySkills"
                :options="userSkills"
                multiple
                label="Primary Skills"
              />
            </div>

            <div v-show="primarySkills.length && secondarySkills.length">

              <button
                v-b-tooltip.hover.top="skillCondition"
                class="mr-75 ml-50 my-team-skill-button"
                @click="skillCondition = skillCondition == 'AND' ? 'OR' : 'AND'"
              >
                {{ skillCondition == 'AND' ? '&&' : '| |' }}
              </button>
            </div>

            <div>
              <custom-dropdown
                v-model="secondarySkills"
                :options="userSkills"
                multiple
                label="Secondary Skills"
              />
            </div>
            <div
              v-show="primarySkills.length && secondarySkills.length"
              class="my-team-skill-button"
            >
              ]
            </div>

            <div>
              <custom-dropdown
                v-model="is_pool"
                :options="isPoolList"
                :search-box="false"
                :hide-close="true"
                label="Pool"
              />
            </div>
            <option-drop-down v-model="perPage" />

          </div>

          <div class="d-flex align-items-center justify-content-end mt-50 w-100">
            <p
              class="filter-title "
              style="margin-right: 60px;"
            />
            <b-input-group
              class="input-group-merge search-project"
              style="min-width: 25%; max-width: 25%; width: 25%"
            >
              <b-form-input
                v-model="debouncedSearch"
                placeholder="Search by Employee Name"
              />

              <b-input-group-append is-text>
                <feather-icon
                  v-if="debouncedSearch"
                  icon="XIcon"
                  @click="debouncedSearch=null, search = null"
                />
                <feather-icon icon="SearchIcon" />
              </b-input-group-append>
            </b-input-group>
            <div class="ml-1">

              <button
                class="apply-filter filterRedesign mr-75"
                @click="ResumeData()"
              >
                Apply Filter
              </button>
              <button
                class="apply-filter-clear filterRedesign"
                @click="clearFilter()"
              >
                Clear
              </button>
            </div>

          </div>

        </div>
      </div>
    </div>
    <!-- Filter End -->

    <!-- member table start      -->
    <div class="myteamTbl mb-1">
      <table-loader
        v-if="loading"
        :fields="fields"
      />
     
      <b-table
        v-else
        :items="items"
        :fields="fields" 
        :no-border-collapse="noCollapse"
        responsive
        @row-clicked="row => userSummary(row.user_id)"
        hover
      >
        <template #cell(full_name)="data">
                <div class="d-flex align-items-center new-time-report">
                  <b-avatar size="30" :src="data.item.user.picture"
                  :text="(data.item.user.full_name || '').split(' ')[0] | avatarText" style="background-color: #f97753"  v-if="data.item.user.full_name" />
                  <div class="emp-detail">
                    <p class="emp-name">
                      {{ data.item.user.full_name ? data.item.user.full_name : "" }}
                    </p>
                  </div>
                </div>
              </template>
        <template #cell(manage_by)="data">
          <div class="d-flex align-items-center">
            <p
              v-b-tooltip.hover.bottom="data.item.user.manage_by_user
                ? data.item.user.manage_by_user.full_name
                : ''
              "
            >
              {{
                data.item.user.manage_by_user.full_name
              }}
            </p>

          </div>
        </template>
        <template #cell(reporting_to)="data">
          <div class="d-flex align-items-center">
            <p
              v-b-tooltip.hover.bottom="data.item.user.users ? data.item.user.users.full_name : ''
              "
            >
              {{ data.item.user.users.full_name }}
            </p>
          </div>
        </template>

        <template #cell(primary_skill)="data" class="d-flex">
          <div class="d-flex align-items-center teamSkills">
            <template v-if="data.item.user.primary && data.item.user.primary.length">
              <div v-for="(skill, index) in data.item.user.primary" :key="skill.id">
                <b-badge
                  v-if="index < 2"
                  pill
                  :variant="skillBackground()"
                  class="text-nowrap"
                >
                  {{ skill.name }}
                </b-badge>
              </div>

              <div v-if="data.item.user.primary.length > 2">
                <div
                  v-b-tooltip.hover.top="data.item.user.primary.map(s => s.name).join(', ')"
                  class="skillMore d-flex justify-content-center align-items-center"
                >
                  <feather-icon
                    icon="PlusIcon"
                    size="12"
                  />
                  {{ data.item.user.primary.length - 2 }}
                </div>
              </div>
            </template>
          </div>
        </template>

        <template #cell(secondary_skill)="data" class="d-flex">
          <div class="d-flex align-items-center teamSkills">
            <template v-if="data.item.user.secondary && data.item.user.secondary.length">
              <div v-for="(skill, index) in data.item.user.secondary" :key="skill.id">
                <b-badge
                  v-if="index < 2"
                  pill
                  :variant="skillBackground()"
                  class="text-nowrap"
                >
                  {{ skill.name }}
                </b-badge>
              </div>

              <div v-if="data.item.user.secondary.length > 2">
                <div
                  v-b-tooltip.hover.top="data.item.user.secondary.map(s => s.name).join(', ')"
                  class="skillMore d-flex justify-content-center align-items-center"
                >
                  <feather-icon
                    icon="PlusIcon"
                    size="12"
                  />
                  {{ data.item.user.secondary.length - 2 }}
                </div>
              </div>
            </template>
          </div>
        </template>

        <template #cell(department)="data">
          {{
            data.item.user.department ? data.item.user.department.name : ' '
          }}
        </template>
        <template #cell(division)="data">
          {{
            data.item.user.division ? data.item.user.division.name : ' '
          }}
        </template>
        <template #cell(designation)="data">
          {{
            data.item.user.designation ? data.item.user.designation.name : ' '
          }}
        </template>
        <template #cell(file_name)="data">
          {{ data.item.file_name}}
        </template>
        <template #cell(resume_description)="data">
          <p v-b-tooltip.hover.top="data.item.description" class="resume_description">
            {{ data.item.description | description200}}
          </p>
        </template>
        <template #cell(resume_link)="data" class="justify-content-center">
          <div v-if="data.item.google_drive_link" @click.stop>
            <a :href="data.item.google_drive_link" target="_blank">Open Link</a>
          </div>
        </template>
        <template #cell(resume_file)="data" @click.stop>
          <div v-if="data.item.url" class="d-flex align-items-center" @click.stop>
            <!-- View Icon -->
            <div
              data-tooltip-id="View"
              data-tooltip-content="View"
              class="cursor-pointer mr-3"
              @click="openFileInNewTab(data.item.url)"
            >
              <feather-icon icon="EyeIcon" class="edit-icon" size="22" />
            </div>

            <!-- Download Icon -->
            <div
              data-tooltip-id="Download"
              data-tooltip-content="Download"
              class="cursor-pointer"
              @click="downloadFile(data)"
            >
              <feather-icon icon="DownloadIcon" class="edit-icon" size="22" />
            </div>
          </div>
        </template>

      </b-table>

      <!-- pagination section -->
      <Pagination
        v-if="totalCount > 0 && !loading && !isGetTotalUserCount"
        :current-page="currentPage"
        :per-page="perPage"
        :total-count="totalCount"
        @currentPage="currentPage = $event"
      />
      <!-- pagination section complete here -->

    </div>
    <!-- member table end  -->

    <!-- data table complete -->
    <img
      v-if="!loading && totalCount == 0"
      src="@/assets/images/nodatafound/nodata.svg"
      alt="no-data"
      class="no-data-img"
    >

  </div>
</template>

<script>
import mixinResumeList from "@/mixin/resume/resumeList/index";
import { BTable, BButton, BAvatar, BBadge } from "bootstrap-vue";
import TableLoader from "../../components/loaders/table-loading.vue";
import SkeletonLoaderVue from "skeleton-loader-vue";

export default {
  name: "ResumeList",
  mixins: [mixinResumeList],
  components: {
    BAvatar,
    TableLoader,
    SkeletonLoaderVue,
    BTable,
    BButton,
    BBadge,
  },
};
</script>

<style lang="scss" scoped>
@import "./../../assets/scss/component-css/masterSettingFilter.scss";

.myteamTbl .table tbody td p.resume_description{
  width: 300px !important;
  overflow-wrap: break-word;
  white-space: break-spaces;
}

.myteamTbl .table tbody td p.resume_description{
  width: 300px !important;
  overflow-wrap: break-word;
  white-space: break-spaces;
}

</style>
